<app-workflow-conditions-editor
  [variables]="variables"
  [value]="value"
  (valueChange)="onValueChange($event)"></app-workflow-conditions-editor>


